var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handleIcon"},[_c('i',{class:!_vm.isMode ? 'el-icon-edit' : 'el-icon-back',on:{"click":_vm.modeChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }